/* Hiba's Collection theme — vanilla JS, no dependencies. */
(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};
  (function () { var ta = document.createElement('textarea'); Object.keys(S).forEach(function (k) { ta.innerHTML = S[k]; S[k] = ta.value; }); })();
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = T.moneyFormat || 'Rs.{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      var frac = parts[1] ? dec + parts[1] : '';
      if (frac === dec + '00') frac = '';
      return whole + frac;
    }
    var m = fmt.match(re);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = withDelims(cents, 2, "'", '.'); break;
      default: val = withDelims(cents, 2);
    }
    return fmt.replace(re, val).replace(/<[^>]*>/g, '');
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- Drawers ---------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null, lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer();
    lastFocus = document.activeElement;
    el.classList.add('is-open'); overlay && overlay.classList.add('is-open');
    document.body.classList.add('lock'); openDrawerEl = el;
    setTimeout(function () { el.focus(); }, 50);
  }
  function closeDrawer() {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open'); overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('lock'); openDrawerEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  overlay && overlay.addEventListener('click', function () { closeDrawer(); closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-menu],[data-open-cart],[data-open-filters],[data-close-drawer],[data-open-search],[data-close-search]');
    if (!t) return;
    if (t.hasAttribute('data-open-menu')) { e.preventDefault(); openDrawer($('#MenuDrawer')); }
    else if (t.hasAttribute('data-open-cart')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-open-filters')) { e.preventDefault(); openDrawer($('#FilterDrawer')); }
    else if (t.hasAttribute('data-close-drawer')) { e.preventDefault(); closeDrawer(); }
    else if (t.hasAttribute('data-open-search')) { e.preventDefault(); openSearch(); }
    else if (t.hasAttribute('data-close-search')) { e.preventDefault(); closeSearch(); }
  });

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  function setHeaderH() { if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
  setHeaderH(); window.addEventListener('resize', setHeaderH);
  window.addEventListener('scroll', function () { header && header.classList.toggle('is-stuck', window.scrollY > 4); }, { passive: true });

  /* ---------- Announcement rotation (mobile) ---------- */
  var annItems = $$('.announcement__item');
  if (annItems.length > 1) {
    var ai = 0;
    setInterval(function () {
      if (window.innerWidth >= 990) return;
      annItems[ai].classList.remove('is-active'); ai = (ai + 1) % annItems.length; annItems[ai].classList.add('is-active');
    }, 3800);
  }

  /* ---------- Search ---------- */
  var searchModal = $('#SearchModal');
  function openSearch() { if (!searchModal) return; searchModal.classList.add('is-open'); overlay && overlay.classList.add('is-open'); var i = $('input[type=search]', searchModal); setTimeout(function () { i && i.focus(); }, 60); }
  function closeSearch() { if (!searchModal || !searchModal.classList.contains('is-open')) return; searchModal.classList.remove('is-open'); if (!openDrawerEl) overlay && overlay.classList.remove('is-open'); }
  var pInput = $('[data-predictive-input]'), pResults = $('[data-predictive-results]'), pTimer;
  if (pInput && pResults && T.routes && T.routes.predictive) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      pTimer = setTimeout(function () {
        fetch(T.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            pResults.innerHTML = items.map(function (p) {
              return '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '&width=120" alt="" loading="lazy">' : '') + '<span><strong style="display:block;font-size:14px">' + esc(p.title) + '</strong><span class="muted" style="font-size:13px">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
            }).join('');
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  var drawer = $('#CartDrawer');
  function fetchCart() { return fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = count; });
  }
  function propsText(item) {
    var p = item.properties || {};
    return Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k] !== '' && p[k] != null; })
      .map(function (k) { return k + ': ' + p[k]; }).join(' · ');
  }
  function lineHTML(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '';
    var variant = item.product_has_only_default_variant ? '' : '<span class="line__variant">' + esc(item.variant_title || '') + '</span>';
    var was = item.original_line_price > item.final_line_price ? '<s class="price__was">' + formatMoney(item.original_line_price) + '</s>' : '';
    var props = propsText(item);
    if (props) variant += '<span class="line__variant line__props">' + esc(props) + '</span>';
    return '<div class="line" data-key="' + esc(item.key) + '">' +
      '<a class="line__img" href="' + item.url + '">' + img + '</a>' +
      '<div class="line__info"><a class="line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
      '<div class="price"><span class="price__now">' + formatMoney(item.final_line_price) + '</span>' + was + '</div>' +
      '<div class="line__qty"><button type="button" data-qty-change="' + (item.quantity - 1) + '" aria-label="-">−</button><span>' + item.quantity + '</span><button type="button" data-qty-change="' + (item.quantity + 1) + '" aria-label="+">+</button></div></div>' +
      '<button type="button" class="line__remove" data-qty-change="0">' + esc(S.remove || 'Remove') + '</button></div>';
  }
  var lastCart = null;
  function renderCart(cart) {
    lastCart = cart;
    updateCounts(cart.item_count);
    if (!drawer) return;
    var lines = $('[data-cart-lines]', drawer), empty = $('[data-cart-empty]', drawer), foot = $('[data-cart-foot]', drawer);
    lines.innerHTML = cart.items.map(lineHTML).join('');
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.items_subtotal_price);
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    var savedRow = $('[data-cart-saved-row]', drawer);
    if (savedRow) { savedRow.hidden = !(cart.total_discount > 0); $('[data-cart-saved]', drawer).textContent = '– ' + formatMoney(cart.total_discount); }
    // free shipping bar
    var bar = $('[data-ship-bar]', drawer), th = T.freeShipping || 0;
    if (bar) {
      if (th > 0 && cart.item_count > 0) {
        var rem = th - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / th * 100));
        bar.hidden = false;
        $('[data-ship-fill]', bar).style.width = pct + '%';
        $('[data-ship-text]', bar).textContent = rem > 0 ? (S.shipAway || "You're {amount} away from FREE delivery").replace('{amount}', formatMoney(rem)) : (S.shipFree || 'You unlocked FREE delivery!');
      } else bar.hidden = true;
    }
    renderUpsell(cart);
  }
  var upsellCache = {};
  function renderUpsell(cart) {
    var wrap = drawer && $('[data-upsell]', drawer);
    if (!wrap || !T.upsell || !cart.items.length) { if (wrap) wrap.hidden = true; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var go = function (products) {
      var p = (products || []).filter(function (x) { return inCart.indexOf(x.id) === -1 && x.available; })[0];
      if (!p) { wrap.hidden = true; return; }
      var v = p.variants.filter(function (x) { return x.available; })[0];
      var th = T.freeShipping || 0, rem = th - cart.total_price;
      var note = th > 0 && rem > 0 && v.price >= rem ? (S.unlocksFree || 'unlocks FREE delivery') : '';
      var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
      $('[data-upsell-card]', wrap).innerHTML = '<div class="upsell__card">' + img + '<div class="upsell__info"><a href="' + p.url + '">' + esc(p.title) + '</a><small>' + formatMoney(v.price) + (note ? ' · ' + esc(note) : '') + '</small></div><button type="button" class="upsell__add" data-add-variant="' + v.id + '">+ ' + esc(S.add || 'ADD') + '</button></div>';
      wrap.hidden = false;
    };
    if (upsellCache[pid]) return go(upsellCache[pid]);
    fetch(T.routes.recommendations + '.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { upsellCache[pid] = d.products || []; go(upsellCache[pid]); })
      .catch(function () { wrap.hidden = true; });
  }
  function openCart() {
    if (!drawer) { window.location.href = T.routes.cart; return; }
    openDrawer(drawer);
    fetchCart().then(renderCart);
  }
  function changeLine(key, qty) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function addItems(items) {
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty-change]');
      if (q) { var line = q.closest('[data-key]'); line.style.opacity = '.5'; changeLine(line.getAttribute('data-key'), parseInt(q.getAttribute('data-qty-change'), 10)); return; }
      var a = e.target.closest('[data-add-variant]');
      if (a) { a.disabled = true; addItems([{ id: parseInt(a.getAttribute('data-add-variant'), 10), quantity: 1 }]).then(function () { return fetchCart(); }).then(renderCart).catch(function () { toast(S.error); }); return; }
      var w = e.target.closest('[data-wa-cart]');
      if (w) {
        e.preventDefault();
        var c = lastCart; if (!c) return;
        var lines = c.items.map(function (i) { var pt = propsText(i); return '• ' + i.product_title + (i.product_has_only_default_variant ? '' : ' (' + i.variant_title + ')') + (pt ? ' [' + pt + ']' : '') + ' × ' + i.quantity + ' — ' + formatMoney(i.final_line_price); });
        var msg = (S.waCartIntro || 'Assalam o Alaikum! I would like to order:') + '\n' + lines.join('\n') + '\nTotal: ' + formatMoney(c.total_price);
        window.open('https://wa.me/' + w.getAttribute('data-wa') + '?text=' + encodeURIComponent(msg), '_blank');
      }
    });
  }
  function handleAddForm(form, btn) {
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10), qty = parseInt(fd.get('quantity') || '1', 10);
    if (!id) return;
    var btns = btn ? [btn] : [];
    if (form.id) btns = btns.concat($$('button[form="' + form.id + '"]'));
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    // Post the whole form so line-item properties added by apps (e.g. Easify options), selling plans etc. are kept.
    if (!fd.get('quantity')) fd.set('quantity', String(qty));
    fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); openDrawer(drawer); toast(S.added || 'Added to bag'); })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.error || 'Something went wrong'); })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-product-form],[data-quick-add]') || !drawer) return;
    e.preventDefault();
    handleAddForm(f, e.submitter || $('button[type=submit]', f));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-all]'); if (!b) return;
    var ids = b.getAttribute('data-add-all').split(',').filter(Boolean).map(function (x) { return { id: parseInt(x, 10), quantity: 1 }; });
    if (!ids.length) return;
    b.classList.add('is-loading');
    addItems(ids).then(fetchCart).then(function (c) { renderCart(c); openDrawer(drawer); }).catch(function (err) { toast((err && err.description) || S.error); }).then(function () { b.classList.remove('is-loading'); });
  });
  if (drawer && T.cartCount > 0) fetchCart().then(renderCart).catch(function () {});

  /* ---------- Qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-qty-minus],[data-qty-plus]'); if (!m) return;
    var input = $('input', m.closest('[data-qty]')); var v = parseInt(input.value, 10) || 1;
    input.value = m.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', sec);
    var idInput = form && $('[data-variant-id]', form);
    var current = product.variants.filter(function (v) { return idInput && v.id === parseInt(idInput.value, 10); })[0] || product.variants[0];

    // Gallery
    var main = $('[data-gallery-main]', sec), thumbs = $$('[data-thumb]', sec), idx = $('[data-gallery-index]', sec);
    function goTo(i) { if (!main) return; main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (main) main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (idx) idx.textContent = i + 1;
    }, { passive: true });

    // Variant picker
    var picker = $('[data-variant-picker]', sec);
    function selectedOptions() { return product.options.map(function (_, i) { var c = $('input[data-option-index="' + i + '"]:checked', sec); return c ? c.value : null; }); }
    function updateAvailability() {
      if (!picker) return;
      var sel = selectedOptions();
      product.options.forEach(function (_, i) {
        $$('input[data-option-index="' + i + '"]', sec).forEach(function (inp) {
          var test = sel.slice(); test[i] = inp.value;
          var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function applyVariant(v) {
      if (v && sec.querySelector('[data-hc-sale]') && !(v.compare_at_price > v.price)) { v = Object.assign({}, v, { compare_at_price: v.price, price: Math.round(v.price * 0.7 / 100) * 100 }); }
      current = v;
      if (idInput && v) idInput.value = v.id;
      $$('[data-price]', sec).forEach(function (el) { el.textContent = v ? formatMoney(v.price) : ''; });
      var onSale = v && v.compare_at_price > v.price;
      $$('[data-compare]', sec).forEach(function (el) { el.hidden = !onSale; el.textContent = onSale ? formatMoney(v.compare_at_price) : ''; });
      $$('[data-save]', sec).forEach(function (el) { el.hidden = !onSale; el.textContent = onSale ? (S.save || 'Save') + ' ' + formatMoney(Math.round((v.compare_at_price - v.price) / 100) * 100) : ''; });
      var pb = $('[data-pct-badge]', sec); if (pb) { pb.hidden = !onSale; if (onSale) pb.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      $$('[data-atc]', sec).forEach(function (b) { b.disabled = !(v && v.available); var l = $('[data-atc-label]', b); if (l) l.textContent = !v ? S.unavailable : (v.available ? S.addToCart : S.soldOut); });
      if (v && v.featured_media && main) {
        var slides = $$('[data-media-id]', main);
        slides.forEach(function (s, i) { if (parseInt(s.getAttribute('data-media-id'), 10) === v.featured_media.id) goTo(i); });
      }
      if (v) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
      product.options.forEach(function (_, i) { var lab = $('[data-option-value="' + i + '"]', sec); var c = $('input[data-option-index="' + i + '"]:checked', sec); if (lab && c) lab.textContent = c.value; });
      updateAvailability();
    }
    if (picker) {
      picker.addEventListener('change', function () {
        var sel = selectedOptions();
        var v = product.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        applyVariant(v || null);
      });
      updateAvailability();
    }

    // Sticky add to bag
    var sticky = $('[data-sticky-atc]', sec), mainBtn = form && $('[data-atc]', form);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show);
      }).observe(mainBtn);
    }

    // Order on WhatsApp
    var wa = $('[data-wa-order]', sec);
    if (wa) wa.addEventListener('click', function (e) {
      e.preventDefault();
      var qty = form ? (parseInt(($('input[name=quantity]', form) || {}).value, 10) || 1) : 1;
      var vt = current && current.title !== 'Default Title' ? ' (' + current.title + ')' : '';
      var msg = 'Assalam o Alaikum! I would like to order:\n• ' + wa.getAttribute('data-title') + vt + ' × ' + qty + ' — ' + formatMoney((current ? current.price : product.price) * qty) + '\n' + window.location.origin + (sec.getAttribute('data-product-url') || '');
      window.open('https://wa.me/' + wa.getAttribute('data-wa') + '?text=' + encodeURIComponent(msg), '_blank');
    });

    // Delivery estimate (Pakistan time, Sundays skipped)
    var del = $('[data-delivery]', sec);
    if (del) {
      var cities = (del.getAttribute('data-cities') || '').split(/\n|\r/).map(function (l) { var p = l.split(':'); return p.length >= 3 ? { name: p[0].trim(), min: parseInt(p[1], 10), max: parseInt(p[2], 10) } : null; }).filter(Boolean);
      var sel = $('[data-delivery-city]', del), out = $('[data-delivery-date]', del);
      var saved = null; try { saved = localStorage.getItem('hc_city'); } catch (e) {}
      cities.forEach(function (c) { var o = document.createElement('option'); o.value = c.name; o.textContent = c.name; if (c.name === saved) o.selected = true; sel.appendChild(o); });
      var nowPk = function () { var d = new Date(); return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 5 * 3600000); };
      var cutoff = parseInt(del.getAttribute('data-cutoff'), 10) || 16;
      var addWorkDays = function (d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) n--; } return r; };
      var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var calc = function () {
        var c = cities.filter(function (x) { return x.name === sel.value; })[0] || cities[cities.length - 1]; if (!c) return;
        var now = nowPk(); var start = new Date(now);
        if (now.getHours() >= cutoff || now.getDay() === 0) start = addWorkDays(now, 1);
        var a = addWorkDays(start, c.min), b = addWorkDays(start, c.max);
        out.textContent = (window.theme.deliveredLabel || 'Delivered') + ' ' + fmt(a) + ' – ' + fmt(b);
        try { localStorage.setItem('hc_city', c.name); } catch (e) {}
        var row = $('[data-cutoff-row]', del), txt = $('[data-cutoff-text]', del);
        if (row && now.getDay() !== 0 && now.getHours() < cutoff) {
          var mins = (cutoff - now.getHours()) * 60 - now.getMinutes();
          txt.textContent = 'Order within ' + Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm for dispatch today';
          row.hidden = false;
        } else if (row) row.hidden = true;
      };
      sel.addEventListener('change', calc); calc();
    }
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown'); if (!raw) return;
    var end = new Date(raw.length === 16 ? raw + ':00+05:00' : raw);
    if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var s = Math.floor((end - new Date()) / 1000);
      if (s <= 0) { el.style.display = 'none'; return false; }
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400)); $('[data-h]', el).textContent = pad(Math.floor(s % 86400 / 3600));
      $('[data-m]', el).textContent = pad(Math.floor(s % 3600 / 60)); $('[data-s]', el).textContent = pad(s % 60);
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  });

  /* ---------- Collection ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-load-more-btn]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-loading');
    fetch(b.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-product-grid]'), newGrid = $('[data-product-grid]', doc);
      if (grid && newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
      var newMore = $('[data-load-more]', doc), more = $('[data-load-more]');
      if (more && newMore) more.replaceWith(newMore); else if (more) more.remove();
      window.history.replaceState({}, '', b.href);
    }).catch(function () { window.location.href = b.href; });
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = $('[data-recs]', d); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }); io.observe(el); } else load();
  });


  /* ---------- Hero spotlight ---------- */
  function alphaBox(img) {
    if (img._box !== undefined) return img._box;
    try {
      var n = 96, c = document.createElement('canvas'); c.width = c.height = n;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, t = n, b = -1, l = n, r = -1;
      for (var y = 0; y < n; y++) for (var i = 0; i < n; i++) { if (d[(y * n + i) * 4 + 3] > 20) { if (y < t) t = y; if (y > b) b = y; if (i < l) l = i; if (i > r) r = i; } }
      // not a transparent cut-out: keep the CSS layout
      img._box = (b < 0 || (b - t) < n * 0.2 || (r - l) > n * 0.97 && (b - t) > n * 0.97) ? null : { t: t / n, b: (b + 1) / n, l: l / n, r: (r + 1) / n };
    } catch (e) { img._box = null; }
    return img._box;
  }
  /* For Her / For Him tiles (desktop): fit the bottle's real outline inside the media box */
  var tileMq = window.matchMedia('(min-width: 750px)');
  function fitTileImg(img) {
    var m = img.closest('.tile__media--product'); if (!m) return;
    if (!tileMq.matches) { img.removeAttribute('style'); return; }
    var W = m.clientWidth, H = m.clientHeight; if (!W || !H || !img.naturalWidth) return;
    var box = alphaBox(img); if (!box) return;
    var S = Math.min(H / (box.b - box.t), W * 0.92 / (box.r - box.l));
    img.style.cssText = 'position:absolute;max-width:none;max-height:none;transform:none;width:' + S + 'px;height:' + S + 'px;left:' + (W / 2 - S * (box.l + box.r) / 2) + 'px;top:' + ((H - S * (box.b - box.t)) / 2 - S * box.t) + 'px';
  }
  var tileImgs = $$('.tile__media--product img');
  tileImgs.forEach(function (img) { if (img.complete) fitTileImg(img); else img.addEventListener('load', function () { fitTileImg(img); }); });
  var tt; window.addEventListener('resize', function () { clearTimeout(tt); tt = setTimeout(function () { tileImgs.forEach(fitTileImg); }, 150); });

  function fitStageImg(img) {
    var slide = img.closest('[data-hstage-slide]'); if (!slide) return;
    var W = slide.clientWidth, H = slide.clientHeight; if (!W || !H || !img.naturalWidth) return;
    var box = alphaBox(img); if (!box) return;
    var S = Math.min(H * 0.97 / (box.b - box.t), W * 0.78 / (box.r - box.l));
    img.style.cssText = 'position:absolute;width:' + S + 'px;height:' + S + 'px;left:' + (W / 2 - S * (box.l + box.r) / 2) + 'px;top:' + (H - S * box.b) + 'px';
    img.classList.add('is-fit');
  }
  $$('[data-hstage]').forEach(function (stage) {
    var slides = $$('[data-hstage-slide]', stage), cards = $$('[data-hstage-card]', stage), dots = $$('[data-hstage-dot]', stage);
    var imgs = $$('.hstage__img', stage), cur = 0, timer = null;
    imgs.forEach(function (img) { if (img.complete) fitStageImg(img); else img.addEventListener('load', function () { fitStageImg(img); }); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { imgs.forEach(fitStageImg); }, 150); });
    function show(n) {
      cur = (n + slides.length) % slides.length;
      [slides, cards, dots].forEach(function (list) { list.forEach(function (el, i) { el.classList.toggle('is-active', i === cur); }); });
      slides.forEach(function (el, i) { el.setAttribute('tabindex', i === cur ? '0' : '-1'); });
      cards.forEach(function (el, i) { if (i === cur) { el.removeAttribute('aria-hidden'); el.removeAttribute('tabindex'); } else { el.setAttribute('aria-hidden', 'true'); el.setAttribute('tabindex', '-1'); } });
      var img = $('.hstage__img', slides[cur]); if (img && img.loading === 'lazy' && !img.complete) img.loading = 'eager';
    }
    var secs = parseInt(stage.getAttribute('data-interval'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stop() { clearInterval(timer); timer = null; }
    function start() { stop(); if (secs > 0 && !reduce && slides.length > 1) timer = setInterval(function () { show(cur + 1); }, secs * 1000); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hstage-dot'), 10)); start(); }); });
    stage.addEventListener('mouseenter', stop); stage.addEventListener('mouseleave', start);
    stage.addEventListener('touchstart', stop, { passive: true });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; start(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });

  /* ---------- Footer accordions open on desktop ---------- */
  if (window.matchMedia('(min-width: 990px)').matches) $$('[data-footer-details]').forEach(function (d) { d.open = true; });
})();


/* 11.11 SALE: 30% OFF badges + sale prices on ReelPlus reels (auto on 1-30 Nov 2026 only) */
(function () {
  var d = new Date(), ymd = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  if (ymd < 20261101 || ymd > 20261130) return;
  var sale = null, waiting = [];
  function load(cb) {
    if (sale) return cb();
    waiting.push(cb); if (waiting.length > 1) return;
    var set = {}, page = 1;
    (function next() {
      fetch('/collections/11-11-sale/products.json?limit=250&page=' + page).then(function (r) { return r.json(); }).then(function (j) {
        (j.products || []).forEach(function (p) { set[p.handle] = 1; });
        if (j.products && j.products.length === 250 && page < 5) { page++; next(); } else { sale = set; waiting.splice(0).forEach(function (f) { f(); }); }
      }).catch(function () { sale = {}; waiting.splice(0).forEach(function (f) { f(); }); });
    })();
  }
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function badge(host, txt) {
    if (!host || host.querySelector(':scope > .hc-reel-badge')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = document.createElement('span'); b.className = 'hc-reel-badge'; b.textContent = txt; host.appendChild(b);
  }
  function fd(host) {
    if (!host || host.querySelector(':scope > .hc-reel-fd')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = document.createElement('span'); b.className = 'hc-reel-fd'; b.textContent = 'FREE DELIVERY'; host.appendChild(b);
  }
  function apply() {
    document.querySelectorAll('.reel-plus-video-container').forEach(function (v) { fd(v); });
    load(function () {
      document.querySelectorAll('[data-product-handle]').forEach(function (el) {
        if (!sale[el.getAttribute('data-product-handle')]) return;
        if (!el.closest('[class*="reel-plus"],[class*="reelPlus"],[id*="reelPlus"]')) return;
        badge(el.closest('.reel-plus-video-container'), '30% OFF');
        badge(el.querySelector('[class*="product_image"],[class*="product-image"]'), '-30%');
        el.querySelectorAll('*').forEach(function (n) {
          if (n.children.length || n.getAttribute('data-hc-done')) return;
          var m = (n.textContent || '').replace(/\u00a0/g, ' ').match(/^\s*(PKR|Rs\.?)\s*([\d,]+(?:\.\d+)?)\s*$/);
          if (!m) return;
          var v = parseFloat(m[2].replace(/,/g, ''));
          n.setAttribute('data-hc-done', '1');
          /* real sale prices since 4 Nov: no price rewrite */
        });
      });
    });
  }
  var css = document.createElement('style');
  css.textContent = '.hc-reel-fd{position:absolute;top:8px;left:8px;z-index:6;background:#14254F;color:#fff;font:700 10px/1 system-ui,-apple-system,sans-serif;letter-spacing:.4px;padding:5px 9px;border-radius:999px;pointer-events:none;box-shadow:0 2px 6px rgba(0,0,0,.25)}.hc-reel-badge{position:absolute;top:8px;right:8px;z-index:6;background:#FC348E;color:#fff;font:700 11px/1 system-ui,-apple-system,sans-serif;letter-spacing:.3px;padding:5px 9px;border-radius:999px;pointer-events:none;box-shadow:0 2px 6px rgba(0,0,0,.25)}.hc-reel-was{opacity:.55;font-weight:400;margin-left:4px}.hc-reel-pill{display:inline-block;background:#FC348E;color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:999px;margin-left:6px;vertical-align:middle}';
  document.head.appendChild(css);
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 250); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
